/** <video-card>: poster + play button; plays the video inline and pauses any other playing card. */
class VideoCard extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.button = this.querySelector('[data-video-play]');
    if (!this.video || !this.button) return;

    this.button.addEventListener('click', this.#play);
    this.video.addEventListener('pause', this.#showButton);
    this.video.addEventListener('ended', this.#showButton);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.#play);
  }

  #play = () => {
    for (const other of document.querySelectorAll('video-card video')) {
      if (other !== this.video) other.pause();
    }
    this.video.controls = true;
    this.button.hidden = true;
    this.video.play();
    this.video.focus();
  };

  #showButton = () => {
    if (this.video.seeking) return;
    this.video.controls = false;
    this.button.hidden = false;
  };
}

if (!customElements.get('video-card')) customElements.define('video-card', VideoCard);
